export class LocalStorageUtils {
  static getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);

    if (!item) return null;

    return JSON.parse(item);
  }

  static setItem<T>(key: string, item: T) {
    localStorage.setItem(key, JSON.stringify(item));
  }
}
